import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)



var state={
    lang:'zh',
    // base_url:"http://emaills.kplcloud.com",
    base_url:"https://vapi.comergegroup.com/api",
    site_url:"https://vapi.comergegroup.com/",

    ship_url:"http://api.shipxy.com/apicall",
    ship_url_k:"f534bb6699234c8ab36061a4ea5b0058",
    ship_url_v:"2"


    // base_url:"https://api.edecoa.com"
}

var mutations={

    change_lang(lang){
       state.lang = lang
    }
}


const settings = new Vuex.Store({state, mutations})
		
export default settings;